module.exports = __webpack_public_path__ + "472c5d22b96b2720f1d5c4625603cdbc.MP3";